import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function Profile() {
  const { user } = useAuth();
  const [form, setForm]   = useState({ name: user?.name || '', phone: user?.phone || '', department: user?.department || '', designation: user?.designation || '' });
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [msg, setMsg]     = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [saving, setSaving] = useState(false);

  const saveProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    try {
      await api.put(`/users/${user.id}`, form);
      setMsg('Profile updated successfully.');
    } catch (err) {
      setMsg(err.response?.data?.message || 'Update failed');
    } finally {
      setSaving(false);
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.newPw !== pwForm.confirm) { setPwMsg('Passwords do not match'); return; }
    try {
      await api.put(`/users/${user.id}`, { password: pwForm.newPw });
      setPwMsg('Password changed successfully.');
      setPwForm({ current: '', newPw: '', confirm: '' });
    } catch (err) {
      setPwMsg(err.response?.data?.message || 'Failed');
    }
  };

  return (
    <div className="row g-4">
      <div className="col-md-4">
        <div className="content-section text-center">
          <div className="bg-primary rounded-circle d-inline-flex align-items-center justify-content-center text-white mb-3"
            style={{width:80,height:80,fontSize:'2rem'}}>
            {user?.name?.[0]?.toUpperCase()}
          </div>
          <h5 className="fw-bold">{user?.name}</h5>
          <p className="text-muted mb-1">{user?.email}</p>
          <p className="text-muted mb-2 small">{user?.employee_id}</p>
          <span className="badge bg-primary">{user?.role === 'supervisor' ? 'Supervisor' : 'Employee'}</span>
          <hr />
          <div className="text-start small">
            <div className="d-flex justify-content-between py-1 border-bottom"><span className="text-muted">Department</span><span>{user?.department || '—'}</span></div>
            <div className="d-flex justify-content-between py-1"><span className="text-muted">Designation</span><span>{user?.designation || '—'}</span></div>
          </div>
        </div>
      </div>
      <div className="col-md-8">
        <div className="content-section mb-4">
          <h6>Update Profile</h6>
          {msg && <div className="alert alert-info py-2 small">{msg}</div>}
          <form onSubmit={saveProfile}>
            <div className="row g-3">
              <div className="col-sm-6">
                <label className="form-label small">Full Name</label>
                <input className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
              </div>
              <div className="col-sm-6">
                <label className="form-label small">Phone</label>
                <input className="form-control" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
              </div>
              <div className="col-sm-6">
                <label className="form-label small">Department</label>
                <input className="form-control" value={form.department} onChange={e => setForm({...form, department: e.target.value})} />
              </div>
              <div className="col-sm-6">
                <label className="form-label small">Designation</label>
                <input className="form-control" value={form.designation} onChange={e => setForm({...form, designation: e.target.value})} />
              </div>
            </div>
            <button type="submit" className="btn btn-primary mt-3" disabled={saving}>
              {saving ? 'Saving...' : 'Save Changes'}
            </button>
          </form>
        </div>
        <div className="content-section">
          <h6>Change Password</h6>
          {pwMsg && <div className="alert alert-info py-2 small">{pwMsg}</div>}
          <form onSubmit={changePassword}>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label small">New Password</label>
                <input type="password" className="form-control" value={pwForm.newPw} onChange={e => setPwForm({...pwForm, newPw: e.target.value})} required minLength={6} />
              </div>
              <div className="col-12">
                <label className="form-label small">Confirm Password</label>
                <input type="password" className="form-control" value={pwForm.confirm} onChange={e => setPwForm({...pwForm, confirm: e.target.value})} required />
              </div>
            </div>
            <button type="submit" className="btn btn-warning mt-3">Update Password</button>
          </form>
        </div>
      </div>
    </div>
  );
}
